<template>
    <div>
        <div class="modal__background"></div>
        <div class="modal__wrapper">
            <h3>{{ $t("draftEmailHeadline") }}</h3>
            <p>{{ $t("draftEmailText") }}</p>
            <input class="modal__input--text" type="text" v-model="emailInput">
            <button
                @click="sendDraftEmail"
                :disabled="loading"
                class="form__button">
                    <span v-if="loading" class="loader"></span>
                    <span v-else>{{ $t("draftEmailButtonSend") }}</span>
            </button>

            <button
                @click="closeDraftModal"
                class="form__button form__button--hollow">
                    {{ $t("draftEmailButtonCancel") }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'email'
    ],
    emits: [
        'close-draft-modal',
        'send-draft-email'
    ],
    data() {
        return {
            emailInput: '',
            loading: false
        }
    },
    methods: {
        closeDraftModal() {
            this.$emit('close-draft-modal');
        },
        sendDraftEmail() {
            this.loading = true;
            this.$emit('send-draft-email', this.emailInput);
        }
    },
    mounted() {
        this.emailInput = this.email;
    }
}
</script>